import { Component, OnInit } from '@angular/core';
import { ServerService } from 'src/app/services/server.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatPaginator } from '@angular/material';
import { Router } from '@angular/router';
import { FilterTaskComponent } from './filter-task/filter-task.component';
import { ClipBoardService } from '../../services/clipboard.service'

@Component({
  selector: 'app-tasks',
  templateUrl: './tasks.component.html',
  styleUrls: ['./tasks.component.scss']
})
export class TasksComponent implements OnInit {
  authToken = localStorage.getItem('token');
  alltasks: any;
  showComponentLoader: boolean = false;
  showComponentLoader1: boolean = false;
  elasticSearch: any;
  pageIndex: number = 0;
  pageSize: number = 50;
  pagination: any;
  createdAt: any = ""
  updatedAt: any = ""
  dueDate: any = ""
  priority: any = "";
  taskCategory: any = "";
  task_status: any = ""
  filterTaskComponent: MatDialogRef<FilterTaskComponent>

  role: any;
  leadInfo: any;


  constructor(
    private _serverService: ServerService,
    private _router: Router,
    private dialog: MatDialog,
    private clipBoardService: ClipBoardService,
  ) { }

  ngOnInit() {
    this.getAllTask();
  }

  getAllTask() {

    let url = "?per_page=" + this.pageSize + "&page=" + this.pageIndex;

    if (this.priority != "" && this.priority != undefined) {
      url += '&priority=' + this.priority;
    }

    if (this.taskCategory != "" && this.taskCategory != undefined) {
      url += '&task_category=' + this.taskCategory
    }

    if (this.task_status == 'true') {
      url += '&done=' + true
    }

    if (this.task_status == 'false') {
      url += '&done=' + false
    }

    if (this.createdAt != undefined && this.createdAt != "") {
      url += "&created_at=" + JSON.stringify([this.createdAt.formatted.split(" - ")[0], this.createdAt.formatted.split(" - ")[1]]);
    }

    if (this.updatedAt != undefined && this.updatedAt != "") {
      url += "&modified_at=" + JSON.stringify([this.updatedAt.formatted.split(" - ")[0], this.updatedAt.formatted.split(" - ")[1]]);
    }

    if (this.dueDate != undefined && this.dueDate != "") {
      url += "&due_date=" + JSON.stringify([this.dueDate.formatted.split(" - ")[0], this.dueDate.formatted.split(" - ")[1]]);
    }

    // if (this.createdAt != undefined && this.createdAt != "") {
    //   if (this.createdAt.length != undefined && this.createdAt.length != 0) {
    //     url += '&created_at=' + JSON.stringify(this.createdAt)
    //   } else {
    //     this.createdAt = [this.createdAt.beginDate.year + '-' + this.createdAt.beginDate.month + '-' + this.createdAt.beginDate.day, this.createdAt.endDate.year + '-' + this.createdAt.endDate.month + '-' + this.createdAt.endDate.day];
    //     url += '&created_at=' + JSON.stringify(this.createdAt)
    //   }
    // }

    // if (this.updatedAt != undefined && this.updatedAt != "") {
    //   if (this.updatedAt.length != undefined && this.updatedAt.length != 0) {
    //     url += '&modified_at=' + JSON.stringify(this.updatedAt)
    //   } else {
    //     this.updatedAt = [this.updatedAt.beginDate.year + '-' + this.updatedAt.beginDate.month + '-' + this.updatedAt.beginDate.day, this.updatedAt.endDate.year + '-' + this.updatedAt.endDate.month + '-' + this.updatedAt.endDate.day];
    //     url += '&modified_at=' + JSON.stringify(this.updatedAt)
    //   }
    // }

    // if (this.dueDate != undefined && this.dueDate != "") {
    //   if (this.dueDate.length != undefined && this.dueDate.length != 0) {
    //     url += '&due_date=' + JSON.stringify(this.dueDate)
    //   } else {
    //     this.dueDate = [this.dueDate.beginDate.year + '-' + this.dueDate.beginDate.month + '-' + this.dueDate.beginDate.day, this.dueDate.endDate.year + '-' + this.dueDate.endDate.month + '-' + this.dueDate.endDate.day];
    //     url += '&due_date=' + JSON.stringify(this.dueDate)
    //   }
    // }

    this._serverService.get_all_task_by_user(url, this.authToken).subscribe((data) => {
      this.alltasks = data.tasks;
      this.pagination = data.pagination;
      this.showComponentLoader = false;
      // console.log(data)
    })
  }

  getNext(event) {

    this.showComponentLoader = true
    let url1: any = {
      "per_page": event.pageSize,
      "page": event.pageIndex
    };

    let body = {}

    this.pageSize = url1.per_page;
    this.pageIndex = url1.page
    let indexPage = this.pageIndex + 1


    if (this.priority != "" && this.priority != undefined) {
      url1 += '&priority=' + this.priority;
    }

    if (this.taskCategory != "" && this.taskCategory != undefined) {
      url1 += '&task_category=' + this.taskCategory
    }

    if (this.task_status == 'true') {
      url1 += '&done=' + true
    }

    if (this.task_status == 'false') {
      url1 += '&done=' + false
    }

    if (this.createdAt != undefined && this.createdAt != "") {
      url1 += "&created_at=" + JSON.stringify([this.createdAt.formatted.split(" - ")[0], this.createdAt.formatted.split(" - ")[1]]);
    }

    if (this.updatedAt != undefined && this.updatedAt != "") {
      url1 += "&modified_at=" + JSON.stringify([this.updatedAt.formatted.split(" - ")[0], this.updatedAt.formatted.split(" - ")[1]]);
    }

    if (this.dueDate != undefined && this.dueDate != "") {
      url1 += "&due_date=" + JSON.stringify([this.dueDate.formatted.split(" - ")[0], this.dueDate.formatted.split(" - ")[1]]);
    }



    // if (this.elasticSearch.trim() != "") {
    //   body["name"] = this.elasticSearch
    // }

    // if (this.createdAt != undefined && this.createdAt != "") {
    //   body["created_at"] = [this.createdAt.formatted.split(" - ")[0], this.createdAt.formatted.split(" - ")[1]];
    // }
    // if (this.updatedAt != undefined && this.updatedAt != "") {
    //   body["modified_at"] = [this.updatedAt.formatted.split(" - ")[0], this.updatedAt.formatted.split(" - ")[1]];
    // }
    // if (this.dueDate != undefined && this.dueDate != "") {
    //   body["due_date"] = [this.dueDate.formatted.split(" - ")[0], this.dueDate.formatted.split(" - ")[1]];
    // }

    this.showComponentLoader = true
    let url = "?per_page=" + this.pageSize + "&page=" + indexPage;
    this._serverService.get_all_task_by_user(url, this.authToken).subscribe(
      data => {
        this.alltasks = data.tasks
        this.showComponentLoader = false
      },
      err => {
        this.showComponentLoader = false
        // this.clipBoardService.checkServerError(err, this.authToken)
      }
    )
  }

  removeSearch() {
    this.elasticSearch = ""
    this.getAllTask()
  }

  leadProfile(lead, project_id, lead_id) {

    this.showComponentLoader = true

    let body = {
      "query": JSON.stringify(lead_id),
      "filters": {
        "project_id": project_id,
      }
    }

    let url: any;

    this.role = JSON.parse(localStorage.getItem('userInfo')).role;
    this.role == 'SalesAdmin' ? url = "sales/leads_search" : url = "leads_search";

    this._serverService.leadsElasticSearch(url, body, this.authToken).subscribe(data => {  
      sessionStorage.setItem("projectInfo", JSON.stringify(lead.project))
      if(data.leads.length  != 0){
        sessionStorage.setItem("leadInfo", JSON.stringify(data.leads[0]._source));
      }
      
      sessionStorage.setItem("leadId", JSON.stringify(lead_id));
      this.showComponentLoader = false

      if (sessionStorage.getItem("leadInfo") == null) {
        this._router.navigate(["/page/project/leads"]);
        return
      }

      if (sessionStorage.getItem("leadInfo")) {
        this._router.navigate([]).then(result => { window.open('/page/project/leads/profile/' + project_id, '_blank'); });
      }

      //console.log(this.leadInfo)
    },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )

    // sessionStorage.setItem("projectInfo", JSON.stringify(lead.project))
    // sessionStorage.setItem("leadInfo", JSON.stringify(lead));
    // sessionStorage.setItem("leadId", JSON.stringify(lead_id));

    //this._router.navigate([]).then(result => { window.open('/page/project/leads/' + project_id, '_blank'); });


  }

  filter() {

    let body = {}

    if (this.priority != undefined && this.priority != "") {
      body["priority"] = this.priority
    }

    if (this.taskCategory != "" && this.taskCategory != undefined) {
      body['task_category'] = this.taskCategory
    }

    if (this.task_status == 'true') {
      body['done'] = true
    }

    if (this.task_status == 'false') {
      body['done'] = false
    }

    if (this.createdAt != undefined && this.createdAt != "") {
      body["createdAt"] = this.createdAt
    }

    if (this.updatedAt != undefined && this.updatedAt != "") {
      body["updatedAt"] = this.updatedAt
    }

    if (this.dueDate != undefined && this.dueDate != "") {
      body["due_date"] = this.dueDate
    }

    //console.log(body)

    this.filterTaskComponent = this.dialog.open(FilterTaskComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '500px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: body
    });
    this.filterTaskComponent.afterClosed().subscribe(result => {
      //console.log(result)

      if (result != undefined) {
        this.showComponentLoader = true

        if (result.priority != undefined && result.priority != "") {
          this.priority = result.priority
        } else {
          this.priority = ""
        }

        if (result.task_category != undefined && result.task_category != "") {
          this.taskCategory = result.task_category
        } else {
          this.taskCategory = ""
        }

        if (result.done != undefined && result.done != "") {
          this.task_status = result.done
        } else {
          this.task_status = ""
        }

        if (result.createdAt != undefined && result.createdAt != "") {
          this.createdAt = result.createdAt
        } else {
          this.createdAt = ""
        }

        if (result.updatedAt != undefined && result.updatedAt != "") {
          this.updatedAt = result.updatedAt
        } else {
          this.updatedAt = ""
        }

        if (result.due_date != undefined && result.due_date != "") {
          this.dueDate = result.due_date
        } else {
          this.dueDate = ""
        }

        // console.log(this.task_status)
        // return false

        this.getAllTask()
      }

    })
  }

  viewProjectDetail(project: any) {
    if (!project.disable) {
      // localStorage.setItem("projectInfo", JSON.stringify(project))
      sessionStorage.setItem("projectInfo", JSON.stringify(project))
      // this.router.navigate(["/page/project/leads"])
      this._router.navigate([]).then(result => { window.open('/page/project/leads/' + project.id, '_blank'); });
    }
  }

}